import { getIdOrNull, requestWithPromise } from '..'
import { HttpMethods } from '../apiHelper'
import { CREATION_BODY } from '../entities/chatRoom'
import apiClient from './apiClient'

export const getShiftActs = (shift, user) => {
  return requestWithPromise(
    `/api/shifts/${getIdOrNull(shift)}/acts`,
    HttpMethods.GET,
    null,
    user
  )
}

export const createShiftAct = (shift, act, user) => {
  return requestWithPromise(
    `/api/shifts/${getIdOrNull(shift)}/acts`,
    HttpMethods.POST,
    act,
    user
  )
}

export const getShiftChatRooms = (user, shift) => {
  return apiClient.get(user, `api/shifts/${getIdOrNull(shift)}/chat-rooms`)
}

export const addChatRoomToShift = (user, shift, body = CREATION_BODY) => {
  return apiClient.post(user, `api/shifts/${getIdOrNull(shift)}/chat-rooms`, body)
}
